import { Box, Typography } from "@mui/material";
import { ReactNode } from "react";

type ClusterDetailRowProps = {
  title: string;
  detail: ReactNode;
  isScrollable?: boolean;
};

const shortRowTitleStyle = {
  display: "inline-block",
  width: 180,
  fontWeight: "500",
  marginBottom: "8px",
  whiteSpace: "nowrap",
};

const valueScrollableStyle = {
  flex: "1 1 auto",
  minWidth: 0,
  width: "auto",
  maxWidth: "100%",
  overflowX: "auto",
  whiteSpace: "nowrap",
  display: "block",
  WebkitOverflowScrolling: "touch",
} as const;

const rowContainerStyle = {
  display: "flex",
  alignItems: "center",
  minWidth: 0,
  gap: 0,
  width: "100%",
  flexWrap: "nowrap",
} as const;

export function ClusterDetailRow({
  title,
  detail,
  isScrollable = false,
}: ClusterDetailRowProps) {
  return (
    <Box
      sx={{
        ...rowContainerStyle,
        display: "grid",
        gridTemplateColumns: "180px 1fr",
        alignItems: "baseline",
        minWidth: 0,
        width: "100%",
      }}
    >
      <Typography component="span" sx={shortRowTitleStyle}>
        {title}
      </Typography>
      {isScrollable ? (
        <Box
          sx={{
            ...valueScrollableStyle,
            minWidth: 0,
            width: "100%",
            overflowX: "auto",
            whiteSpace: "nowrap",
            display: "block",
          }}
        >
          {detail}
        </Box>
      ) : (
        <Typography component="span" sx={{ minWidth: 0 }}>
          {detail}
        </Typography>
      )}
    </Box>
  );
}

export default ClusterDetailRow;
